import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './img/cloud.svg';
import _imports_1 from './img/baoda.svg';
import _imports_2 from './img/互联网icon.svg';
import _imports_3 from './img/药店icon.svg';
import _imports_4 from './img/nmenu-product-ydh.png';
import _imports_5 from './img/医保代办.svg';
import _imports_6 from './img/医院代办.svg';
import _imports_7 from './img/定制icon.svg';
import _imports_8 from './img/测评icon.svg';
import _imports_9 from './img/advertising/微信咨询.png';
const _withScopeId = n => (_pushScopeId("data-v-4c1fa15f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header_wrap"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = {
  class: "logoArea"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "logo_text"
}, "保达科技", -1));
const _hoisted_7 = {
  class: "right"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon_title"
}, "保达云诊所", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
})], -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon_title"
}, "保达门诊软件", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
})], -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon_title"
}, "互联网医院系统", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
})], -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon_title"
}, "药店管理软件", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
})], -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon_title"
}, "易订货标准版", -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
})], -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon_title"
}, "易订货专业版", -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
})], -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon_title"
}, "易订货旗舰版", -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
})], -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon_title"
}, "医保代办申请", -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
})], -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon_title"
}, "互联网医院代办申请", -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
})], -1));
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon_title"
}, "医疗许可证代办", -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
})], -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon_title"
}, "互联网药品许可证代办", -1));
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  alt: ""
})], -1));
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon_title"
}, "等保测评服务", -1));
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
})], -1));
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon_title"
}, "定制开发", -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
})], -1));
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon_title"
}, "商贸解决方案", -1));
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
})], -1));
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon_title"
}, "工贸解决方案", -1));
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "phone"
}, "18122752759", -1));
const _hoisted_39 = {
  class: "advertising_wrap"
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "img_wrap"
}, null, -1));
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "在线客服", -1));
const _hoisted_42 = [_hoisted_40, _hoisted_41];
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "140px",
    "height": "140px",
    "background": "green"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "100%",
    "height": "100%"
  },
  src: _imports_9,
  alt: ""
})], -1));
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "img_wrap"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "微信咨询")], -1));
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "phone"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "phone_num"
}, "18122752759")], -1));
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "img_wrap"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "电话咨询")], -1));
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "img_wrap"
}, null, -1));
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "申请试用", -1));
const _hoisted_49 = [_hoisted_47, _hoisted_48];
import { ref, watch, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import Form from '@/components/Form';
import dialogCustomer from '@/components/Customer';
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const activeIndex = ref();
    const form = ref(null);
    const customer = ref(null);
    const fixedMenu = ref(true);
    const srcollFn = function () {
      let topScrollTop = document.documentElement.scrollTop;
      if (topScrollTop > 120) {
        fixedMenu.value = true;
      } else {
        fixedMenu.value = false;
      }
    };
    const handleSelect = function (index, indexPath, item, routeResult) {
      // console.log(index)
      // console.log(indexPath)
      // console.log(item)
      // console.log(routeResult)
    };
    const handleLink = function () {
      handleOpen();
    };
    const handleOpen = function () {
      customer.value.openDialog();
    };
    const handleForm = function () {
      form.value.openForm();
    };
    window.addEventListener('scroll', srcollFn);
    onUnmounted(() => {
      window.removeEventListener('scroll', srcollFn, false);
    });
    watch(() => router.currentRoute.value.fullPath, (path, oldPath) => {
      console.log(path);
      activeIndex.value = path;
    }, {
      deep: false,
      immediate: false
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_el_menu = _resolveComponent("el-menu");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      return _openBlock(), _createElementBlock("header", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(fixedMenu.value ? 'header_container fixed' : 'header_container')
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h1", _hoisted_4, [_createVNode(_component_router_link, {
        to: "/",
        title: "保达",
        class: "logo"
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: require('./img/logo.svg'),
          alt: ""
        }, null, 8, _hoisted_5)]),
        _: 1
      }), _hoisted_6])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_menu, {
        "default-active": activeIndex.value,
        class: "myMenu",
        "menu-trigger": "hover",
        mode: "horizontal",
        ellipsis: false,
        router: "",
        onSelect: handleSelect
      }, {
        default: _withCtx(() => [_createVNode(_component_el_menu_item, {
          index: "/home"
        }, {
          default: _withCtx(() => [_createTextVNode("首页")]),
          _: 1
        }), _createVNode(_component_el_sub_menu, {
          "popper-class": "my_menu_popper",
          "popper-offset": -4,
          index: "/products"
        }, {
          title: _withCtx(() => [_createTextVNode("产品中心")]),
          default: _withCtx(() => [_createVNode(_component_el_menu_item, {
            index: "/cloud"
          }, {
            default: _withCtx(() => [_hoisted_8, _hoisted_9]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/clinic"
          }, {
            default: _withCtx(() => [_hoisted_10, _hoisted_11]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/hospital"
          }, {
            default: _withCtx(() => [_hoisted_12, _hoisted_13]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/pharmacy"
          }, {
            default: _withCtx(() => [_hoisted_14, _hoisted_15]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/orderSystem/standard"
          }, {
            default: _withCtx(() => [_hoisted_16, _hoisted_17]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/orderSystem/professional"
          }, {
            default: _withCtx(() => [_hoisted_18, _hoisted_19]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/orderSystem/ultimate"
          }, {
            default: _withCtx(() => [_hoisted_20, _hoisted_21]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_sub_menu, {
          "popper-class": "my_menu_popper",
          "popper-offset": -4,
          index: "/server"
        }, {
          title: _withCtx(() => [_createTextVNode("办证服务")]),
          default: _withCtx(() => [_createVNode(_component_el_menu_item, {
            index: "/medicare"
          }, {
            default: _withCtx(() => [_hoisted_22, _hoisted_23]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/webhospital"
          }, {
            default: _withCtx(() => [_hoisted_24, _hoisted_25]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/approval"
          }, {
            default: _withCtx(() => [_hoisted_26, _hoisted_27]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/medicine"
          }, {
            default: _withCtx(() => [_hoisted_28, _hoisted_29]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/evaluation"
          }, {
            default: _withCtx(() => [_hoisted_30, _hoisted_31]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_sub_menu, {
          "popper-class": "my_menu_popper",
          "popper-offset": -4,
          index: "/solution"
        }, {
          title: _withCtx(() => [_createTextVNode("定制开发")]),
          default: _withCtx(() => [_createVNode(_component_el_menu_item, {
            index: "/individuality"
          }, {
            default: _withCtx(() => [_hoisted_32, _hoisted_33]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/orderSystem/commerceSolution"
          }, {
            default: _withCtx(() => [_hoisted_34, _hoisted_35]),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "/orderSystem/industrySolution"
          }, {
            default: _withCtx(() => [_hoisted_36, _hoisted_37]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/case"
        }, {
          default: _withCtx(() => [_createTextVNode("成功案例")]),
          _: 1
        }), _createVNode(_component_el_menu_item, {
          index: "/about"
        }, {
          default: _withCtx(() => [_createTextVNode("关于保达")]),
          _: 1
        })]),
        _: 1
      }, 8, ["default-active"]), _createElementVNode("div", {
        class: "no_menu"
      }, [_createElementVNode("div", {
        class: "free",
        onClick: handleForm
      }, "免费试用"), _hoisted_38])])])], 2)]), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", {
        class: "item",
        onClick: handleLink
      }, _hoisted_42), _createVNode(_component_el_tooltip, {
        placement: "left",
        effect: "light",
        "popper-class": "connect"
      }, {
        content: _withCtx(() => [_hoisted_43]),
        default: _withCtx(() => [_hoisted_44]),
        _: 1
      }), _createVNode(_component_el_tooltip, {
        placement: "left",
        effect: "light",
        "popper-class": "connect",
        trigger: "hover",
        "append-to": "#app"
      }, {
        content: _withCtx(() => [_hoisted_45]),
        default: _withCtx(() => [_hoisted_46]),
        _: 1
      }), _createElementVNode("div", {
        class: "item",
        onClick: handleForm
      }, _hoisted_49)]), _createVNode(_unref(Form), {
        ref_key: "form",
        ref: form
      }, null, 512), _createVNode(_unref(dialogCustomer), {
        ref_key: "customer",
        ref: customer
      }, null, 512)]);
    };
  }
};